module.exports = __webpack_public_path__ + "static/media/iyaw.25db30f7.svg";